// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const BusinessToContLogs = t.struct({
    busnNm1: t.String,
    busnNm2: t.String,
    compDlrInd: t.String,
    dbaNm: t.String,
    decsdOobInd: t.String,
    entityId: t.Number,
    entrInd: t.String,
    jdDlrInd: t.String,
    legalNmDt: t.String,
    modifyBy: t.String,
    modifyTs: t.String,
    updateInd: t.String
}, {
    defaultProps: {
        busnNm1: '',
        busnNm2: '',
        compDlrInd: '',
        dbaNm: '',
        decsdOobInd: '',
        entityId: 0,
        entrInd: '',
        jdDlrInd: '',
        legalNmDt: '',
        modifyBy: '',
        modifyTs: '',
        updateInd: ''
    },
    name: 'BusinessToContLogs',
    strict: true
});
